module.exports = __webpack_public_path__ + "img/builder-14.72853c77.jpg";